import type { PublicContent } from './fr'

const todo = '[A completar]'

export const pt: PublicContent = {
  common: {
    backHome: '← Voltar ao início',
    updatedPrefix: 'Última atualização:',
    updatedAt: '10 de outubro de 2026',
    draftBanner: 'Texto provisório, em redação: as passagens entre parênteses retos serão completadas.',
    todo,
    footerRights: '© 2026 Boutiklic kaatomi-laafou. Todos os direitos reservados.',
    footerNavAria: 'Páginas legais',
    footerBilling: 'Conformidade de faturação',
    footerPrivacy: 'Política de privacidade',
    footerTerms: 'Condições de utilização (CGV)',
    footerNotice: 'Aviso legal',
    cities: 'Conacri (Guiné)',
    whatsappMessage: 'Olá, tenho uma pergunta sobre o Boutiklic.',
    hours: [{ label: 'Segunda a sexta', value: '8 h – 18 h' }],
    contactSupportLegal: 'Contactar o apoio jurídico',
  },

  notice: {
    docTitle: 'Aviso legal',
    intro: 'Informações legais relativas ao editor e ao alojamento do serviço Boutiklic.',
    eyebrow: 'Informações legais e jurídicas',
    tocTitle: 'Índice e navegação rápida',
    tocAria: 'Índice das secções legais',
    toc: ['Editor do serviço', 'Alojamento', 'Propriedade intelectual', 'Dados pessoais', 'Responsabilidade e Ligações', 'Contacto e Jurisdição'],
    editorTitle: 'Editor do serviço',
    companyLabel: 'Denominação social',
    companyValue: `Boutiklic Technologies ${todo}`,
    formLabel: 'Forma jurídica e capital',
    formValue: '[SAS com capital de 10 000 000 GNF - A completar]',
    seatLabel: 'Sede social',
    regLabel: 'Matrícula e registo legal',
    directorLabel: 'Diretor da publicação',
    directorValue: '[Direção-geral Boutiklic - A completar]',
    contactLabel: 'Contacto oficial',
    hostingTitle: 'Alojamento',
    hostingBefore: 'O serviço e os dados da plataforma ',
    hostingAfter: ' estão alojados em infraestruturas cloud altamente seguras e conformes com as normas internacionais:',
    hostingVisit: 'Visitar o alojador',
    ipTitle: 'Propriedade intelectual',
    ip1: 'Todos os elementos que constituem o serviço Boutiklic (nomeadamente a marca, os logótipos, textos, interfaces gráficas, código-fonte, bases de dados e documentação do software) estão protegidos pelas leis nacionais e internacionais relativas à propriedade intelectual e aos direitos de autor.',
    ip2Before: 'Qualquer reprodução, representação, modificação, difusão ou exploração total ou parcial dos elementos do site e da aplicação SaaS, sem o acordo prévio expresso e escrito da ',
    ip2After: ', é estritamente proibida e pode constituir crime de contrafação.',
    ipNote: 'As marcas, denominações comerciais e logótipos de terceiros que aparecem na plataforma continuam a ser propriedade exclusiva dos respetivos titulares.',
    dataTitle: 'Dados pessoais e Privacidade',
    data1: 'A Boutiklic atribui grande importância à confidencialidade e à segurança dos dados dos comerciantes e dos seus clientes. Os tratamentos de dados efetuados no âmbito da exploração da plataforma respeitam os princípios de transparência, proporcionalidade e segurança, em conformidade com as melhores práticas regulamentares.',
    data2: 'Para saber mais sobre a recolha dos seus dados, o exercício dos seus direitos de acesso, retificação ou apagamento, ou para contactar o nosso encarregado da proteção de dados:',
    dataButton: 'Consultar a política de privacidade',
    liabilityTitle: 'Limitação de responsabilidade',
    liability1: 'A Boutiklic envida todos os esforços para assegurar a exatidão das informações e o funcionamento contínuo dos seus serviços. No entanto, a Boutiklic não pode ser responsabilizada por interrupções momentâneas para manutenção, erros involuntários ou pela inadequação do seu serviço às necessidades específicas de um utilizador em particular.',
    liability2: 'As ligações de hipertexto eventualmente presentes na plataforma que remetem para sites externos não podem comprometer a responsabilidade da Boutiklic quanto ao seu conteúdo ou às suas práticas de gestão de dados.',
    ctaTag: 'Apoio regulamentar',
    ctaTitle: 'Uma questão de ordem jurídica ou regulamentar?',
    ctaText: 'A nossa equipa jurídica e de conformidade está disponível para responder aos seus pedidos relativos a contratos de comerciantes, proteção de dados ou parcerias.',
    ctaHint: 'Resposta garantida em 24 a 48 horas úteis',
  },

  terms: {
    docTitle: 'Condições Gerais de Venda',
    intro: 'Condições aplicáveis à subscrição e à utilização do serviço Boutiklic.',
    eyebrow: 'Condições legais e contratuais',
    draftTitle: 'Documento em fase de finalização jurídica',
    draftText: 'Texto provisório, em redação: as passagens entre parênteses retos serão completadas brevemente.',
    tocTitle: 'Navegação rápida e índice',
    tocAria: 'Índice interativo',
    toc: ['Objeto', 'Subscrição e Preços', 'Rescisão', 'Responsabilidade', 'Direito e Litígios'],
    s1Title: 'Objeto',
    s1Lead: 'As presentes condições regem o acesso e a utilização do serviço Boutiklic (caixa, gestão de stock, faturação).',
    modules: [
      { title: 'Caixa tátil', text: 'Ponto de venda fluido, adaptado à venda em loja física.' },
      { title: 'Gestão de stock', text: 'Inventário dinâmico, limites de alerta e gestão multi-armazém.' },
      { title: 'Faturação', text: 'Orçamentos, talões conformes, recibos por WhatsApp e acompanhamento contabilístico.' },
    ],
    s2Title: 'Subscrição e preços',
    s2Lead: 'Ofertas, preços e modalidades de pagamento:',
    recapTitle: 'Modalidades previstas no contrato',
    recap: [
      { label: 'Planos de subscrição', value: 'Mensal ou Anual', text: 'Faturação antecipada na data de aniversário da conta.' },
      { label: 'Moedas suportadas', value: 'GNF / FCFA / EUR', text: 'Preços transparentes consoante o seu país de atividade.' },
      { label: 'Pagamentos aceites', value: 'Mobile Money e Cartões', text: 'Orange Money, MTN, Wave, cartões bancários Visa/Mastercard.' },
    ],
    s3Title: 'Rescisão',
    s3Lead: 'Condições e prazos de rescisão:',
    s3Bullets: [
      '• A subscrição mensal sem compromisso pode ser interrompida a qualquer momento a partir do espaço de administração da conta do cliente.',
      '• Em caso de rescisão, o cliente dispõe de 30 dias para exportar livremente os seus catálogos de dados, diários de vendas e lançamentos contabilísticos em formato CSV / Excel.',
    ],
    s4Title: 'Responsabilidade',
    s4Lead: 'Limites de responsabilidade do editor e obrigações do utilizador:',
    dutyEditorTitle: 'Obrigações do editor',
    dutyEditorText: 'Aplicação de meios razoáveis para garantir a disponibilidade 24/7 da infraestrutura de software, cópias de segurança cifradas e automáticas diárias.',
    dutyUserTitle: 'Obrigações do utilizador',
    dutyUserText: 'Confidencialidade estrita das credenciais de acesso de administrador e de caixa, cumprimento da legislação comercial e fiscal em vigor.',
    s5Title: 'Direito aplicável e litígios',
    s5Lead: 'Direito aplicável e jurisdição competente:',
    s5P1: 'Em caso de contestação ou litígio relativo à execução ou à interpretação das presentes condições, as partes comprometem-se a privilegiar uma conciliação amigável no prazo de trinta (30) dias úteis.',
    s5P2: 'Na falta de acordo amigável, os tribunais competentes da jurisdição de Conacri serão exclusivamente chamados a decidir.',
    ctaTag: 'Assistência contratual',
    ctaTitle: 'Uma dúvida sobre as nossas condições de venda?',
    ctaText: 'A nossa equipa jurídica e comercial está disponível para esclarecer as modalidades de subscrição e os seus compromissos contratuais.',
    ctaButton: 'Contactar a equipa comercial',
  },

  privacy: {
    docTitle: 'Proteção de dados dos comerciantes',
    intro: 'Como a Boutiklic recolhe, utiliza e protege os dados da sua loja e dos seus clientes.',
    eyebrow: 'Proteção de dados e Privacidade',
    tocTitle: 'Índice interativo',
    tocAria: 'Índice interativo',
    toc: ['Dados recolhidos', 'Finalidades', 'Subcontratantes', 'Conservação', 'Os seus direitos'],
    s1Title: 'Dados recolhidos',
    s1Lead: 'Dados da conta (nome, número de telefone ou e-mail), dados da loja (produtos, stocks, vendas, orçamentos, faturas) e dados dos seus clientes que introduz na aplicação.',
    kinds: [
      { title: 'Dados da conta', text: 'Nome comercial, telemóvel do gerente e e-mail de acesso.' },
      { title: 'Dados da loja', text: 'Catálogo de produtos, stocks, vendas em caixa, orçamentos e faturação.' },
      { title: 'Ficheiro dos seus clientes', text: 'Contactos dos clientes e histórico de compras introduzidos manualmente.' },
    ],
    s2Title: 'Finalidades',
    s2Lead: 'Fornecer o serviço (caixa, stock, faturação), proteger o acesso (código de verificação por SMS) e assegurar a sincronização entre os seus dispositivos.',
    purposes: [
      { title: 'Execução do serviço', text: 'Gestão do seu ponto de venda: cobrança rápida, inventário, reaprovisionamento e emissão de documentos fiscais.' },
      { title: 'Segurança do acesso', text: 'Verificação por código de utilização única (OTP) enviado por SMS ou e-mail para proteger a sua caixa de intrusões.' },
      { title: 'Sincronização', text: 'Atualização instantânea e sem fios dos seus talões, stocks e preços entre o seu terminal, tablet e telemóvel.' },
    ],
    s3Title: 'Subcontratantes',
    s3Lead: `Alojamento: OVH. Envio de SMS: prestadores de mensagens. Armazenamento de ficheiros: ${todo}.`,
    subHostTitle: 'Alojamento cloud principal',
    subHostText: 'OVH Groupe SAS — centros de dados certificados situados em França / UE',
    subHostTag: 'Conforme com o RGPD',
    subSmsTitle: 'Envio de SMS transacionais',
    subSmsText: 'Prestadores especializados no envio de códigos OTP e alertas',
    subSmsTag: 'Mensagens aprovadas',
    subFilesTitle: 'Armazenamento de ficheiros',
    subFilesTag: 'Em especificação',
    s4Title: 'Conservação',
    s4Lead: 'Prazo de conservação dos dados:',
    boxTitle: 'Esclarecimentos contratuais em redação:',
    boxItems: [
      'Conservação ativa garantida durante todo o período legal de subscrição do serviço Boutiklic.',
      'Conservação dos documentos contabilísticos e faturas em conformidade com as obrigações legais fiscais.',
      'Prazo de reversibilidade e exportação completa dos dados do comerciante aquando da rescisão.',
    ],
    s5Title: 'Os seus direitos',
    s5Lead: 'Pode solicitar o acesso, a retificação ou o apagamento dos seus dados escrevendo para:',
    rights: [
      { title: 'Direito de acesso', text: 'Consultar a totalidade dos seus dados' },
      { title: 'Retificação', text: 'Atualizar as informações incorretas' },
      { title: 'Apagamento', text: 'Direito ao apagamento definitivo' },
      { title: 'Portabilidade', text: 'Exportação em formatos padrão (CSV, JSON)' },
    ],
    channelLabel: 'Canal dedicado a pedidos RGPD / Privacidade:',
    channelButton: 'Escrever ao responsável',
    ctaTag: 'Assistência e Conformidade',
    ctaTitle: 'Uma dúvida sobre a gestão dos seus dados?',
    ctaText: 'A nossa equipa dedicada à conformidade e à proteção de dados acompanha-o e responde a todas as suas perguntas com total transparência.',
    ctaButton: 'Exercer os meus direitos / Contactar o DPO',
  },

  billing: {
    docTitle: 'Conformidade de faturação',
    intro: 'Informações sobre a conformidade dos documentos de faturação emitidos com a Boutiklic.',
    eyebrow: 'Conformidade e Regulamentação Fiscal',
    tocTitle: 'Índice do documento',
    tocAria: 'Índice do documento',
    toc: ['Documentos emitidos', 'Aprovação'],
    s1Title: 'Documentos emitidos',
    s1Lead: 'A Boutiklic permite emitir orçamentos, talões e faturas. As menções obrigatórias dependem da regulamentação do seu país.',
    docs: [
      { title: 'Orçamentos', text: 'Orçamentos proforma detalhados, estimativa clara antes da venda com prazo de validade configurável.' },
      { title: 'Talões', text: 'Talões de caixa instantâneos, recibos térmicos compactos ou digitais (SMS / WhatsApp).' },
      { title: 'Faturas', text: 'Faturas oficiais conformes, numeração sequencial, IVA/impostos e rastreabilidade inviolável.' },
    ],
    localTitle: 'Adaptação às regulamentações locais',
    localText: 'A interface da Boutiklic integra os campos de identificação fiscal (NIF, RCCM, chave de registo de IVA) e permite ajustar as taxas de imposto consoante o país de atividade (Guiné, Senegal, zona UEMOA/CEDEAO, França e internacional).',
    s2Title: 'Aprovação',
    s2Before: 'Estado de aprovação oficial da solução de faturação:',
    s2After: '. Não publicar qualquer menção de aprovação sem comprovativo.',
    statusLabel: 'Estado oficial',
    statusTag: 'Em qualificação',
    statusTitle: 'Certificação e aprovação administrativa',
    statusText: 'As referências de aprovação ministerial ou fiscal só são apresentadas após a emissão dos certificados e recibos formais de conformidade.',
    transparency: 'Compromisso de transparência da Boutiklic: nenhuma menção falsa é atribuída aos documentos antes da validação jurídica.',
    ctaTag: 'Apoio Regulamentar e Fiscal',
    ctaTitle: 'Uma dúvida sobre a conformidade das suas faturas?',
    ctaText: 'A nossa equipa de assistência acompanha-o na configuração das menções obrigatórias e na adaptação dos seus documentos à legislação local.',
    ctaButton: 'Contactar o polo de conformidade',
  },

  contact: {
    docTitle: 'Contacto',
    badge: 'Contacto e Apoio',
    h1: 'Vamos falar da sua loja.',
    introBefore: 'Uma dúvida, uma demonstração, um problema técnico: a nossa equipa responde em ',
    langs: ['francês', 'inglês', 'português'],
    introSep1: ', em ',
    introSep2: ' e em ',
    addressTitle: 'Morada',
    phoneTitle: 'Telefone',
    phoneBadge: 'Linha direta',
    whatsappTitle: 'WhatsApp',
    whatsappBadge: 'Online',
    whatsappButton: 'Escrever no WhatsApp',
    hoursTitle: 'Horário',
    asideAria: 'Canais de assistência direta',
    formAria: 'Formulário de contacto',
    fullName: 'Nome completo',
    fullNamePh: 'O seu nome',
    shopName: 'Nome da loja',
    shopNamePh: 'Loja da Mariama',
    email: 'E-mail',
    emailPh: 'voce@exemplo.com',
    phone: 'Telefone',
    phonePh: '+224 620 00 00 00',
    subject: 'Assunto',
    topics: {
      DEMO: 'Pedido de demonstração',
      SUPPORT: 'Assistência e Apoio técnico',
      PRICING: 'Questões sobre subscrições e preços',
      PARTNERSHIP: 'Parceria e Distribuição',
      OTHER: 'Outro pedido',
    },
    message: 'Mensagem',
    messagePh: 'Descreva a sua necessidade...',
    minChars: 'Pelo menos 10 caracteres.',
    attachment: 'Anexo',
    optional: '(opcional)',
    dropLink: 'Carregar um documento',
    dropOr: 'ou arrastar e largar',
    dropHint: 'PNG, JPG, PDF · até 3 ficheiros, 5 MB cada',
    remove: 'Remover',
    honeypot: 'Não preencher',
    send: 'Enviar mensagem',
    sending: 'A enviar…',
    privacyNote: 'As suas informações são confidenciais e seguras. Sem mensagens indesejadas.',
    successTitle: 'Mensagem enviada.',
    successText: 'Obrigado! Responderemos o mais depressa possível por e-mail ou telefone.',
    tooMany: 'Enviou demasiadas mensagens. Tente novamente dentro de uma hora ou escreva-nos no WhatsApp.',
    fileType: '«{name}»: formato não suportado (imagens JPEG, PNG, WebP ou PDF).',
    fileTooBig: '«{name}» excede 5 MB.',
    fileMax: 'No máximo 3 anexos.',
    unitKb: 'KB',
    unitMb: 'MB',
  },
}
